export default "__VITE_ASSET__6ee73313__"